var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.5H10.5M6 2V3.5M8.5 14L11.5 7L14.5 14M9.42188 12H13.5781M8.79062 3.5C8.79062 3.5 8.03125 6.4375 6.21875 8.65625C4.40625 10.875 2.5 12 2.5 12",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C8 10.5 6.90625 9.65625 5.75 8.15625C4.59375 6.65625 4 5.5 4 5.5",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageLogo);
export default __webpack_public_path__ + "static/media/languageLogo.dea87b0dba98a4ad3164619383c42096.svg";
export { ForwardRef as ReactComponent };